import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class ComprasApiService {
  apiURL: string = config.API_DATA_URL + "/compras";
  data: any[] = [];

  constructor(public http: HttpClient) {}

  public GetPendientesCotizar(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetPendientes/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetProveedores(): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetProveedores", { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetFacturasCargoInterno(
    idProveedor: number,
    idSucursal: number,
  ): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        this.apiURL +
          "/GetFacturasCargoInterno/" +
          idProveedor +
          "/" +
          idSucursal,
        { headers },
      )
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GuardarFacturaCargoInterno(factura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(factura);
    return this.http
      .post(this.apiURL + "/GuardarFacturaCargoInterno", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetCotizacionCompras(idValuacion: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetCotizacionCompras/" + idValuacion, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetCuentasxPagar(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetCuentasxPagar/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetCuentasProveedores(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetCuentasProveedores/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetPagosProveedor(idCuentaxPagar: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetPagosProveedor/" + idCuentaxPagar, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetFacturasProveedor(
    idProveedor: number,
    idSucursal: number,
  ): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        this.apiURL + "/GetFacturasProveedor/" + idProveedor + "/" + idSucursal,
        { headers },
      )
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetFacturaAdicional(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetFacturaAdicional/" + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetFacturasAdicionalProveedor(
    idProveedor: number,
    idSucursal: number,
  ): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(
        this.apiURL +
          "/GetFacturasAdicionalProveedor/" +
          idProveedor +
          "/" +
          idSucursal,
        { headers },
      )
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public GetFacturaProveedor(idFacturaProveedor: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetFacturaProveedor/" + idFacturaProveedor, {
        headers,
      })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public AsignarFacturaProveedor(factura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(factura);
    return this.http
      .post(this.apiURL + "/FacturaProveedor", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AsignarFacturaAdicional(factura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(factura);
    return this.http
      .post(this.apiURL + "/FacturaAdicional", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public PagarFactura(pagarFactura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(pagarFactura);
    return this.http
      .post(this.apiURL + "/PagarFactura", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetCotizacionDetalle(idValuacionDetalle: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetCotizacionDetalle/" + idValuacionDetalle, {
        headers,
      })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public AsignarCotizacion(cotizacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(cotizacion);
    return this.http
      .post(this.apiURL + "/AsignarCotizacion", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public EliminarCotizacion(idComprasCotizacion: number): Observable<any> {
    const headers = this.getHeaders();
    const param = JSON.stringify(idComprasCotizacion);
    return this.http
      .post(this.apiURL + "/EliminarCotizacion", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  /////////////////////////
  //// PROCESO COMPRA  ////
  /////////////////////////
  public GetProcesoCompraDetalle(idOrdenServicio: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetProcesoCompraDetalle/" + idOrdenServicio, {
        headers,
      })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public UpdProcesoCompra(plan: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(plan);
    return this.http
      .post(this.apiURL + "/UpdProcesoCompra", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public UpdComentariosCompra(plan: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(plan);
    return this.http
      .post(this.apiURL + "/UpdProcesoCompra/comentarios", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public UpdCnbCompra(plan: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(plan);
    return this.http
      .post(this.apiURL + "/UpdProcesoCompra/cnb", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  ////////////////////////////////////
  //// DETALLE FACTURA PROVEEDOR  ////
  ////////////////////////////////////
  public GetDetalleFacturaProveedor(idOrdenServicio: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.apiURL + "/GetDetalleFacturaProveedor/" + idOrdenServicio, {
        headers,
      })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public EliminarFactura(idFactura: number, idEmpleado: number) {
    const headers = this.getHeaders();
    return this.http
      .delete(
        this.apiURL + "/EliminarFactura/" + idFactura.toString() + "/" + idEmpleado.toString(),
        { headers },
      )
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GenerarFacturaProveedor(factura: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(factura);
    return this.http
      .post(this.apiURL + "/GenerarFacturaProveedor", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetFacturasSucursal(filtro: any): Observable<any> {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    return this.http
      .post(this.apiURL + "/GetFacturasSucursal", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });

    // return this.http.get(this.apiURL + '/GetFacturasSucursal/' + idSucursal + '/' + desde + '/' + hasta, { headers })
    //   .map((response: any) => {
    //     this.data = response;
    //     return this.data;
    //   })
    //   .catch(this.handleError)
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/compras-api.service.ts